import React, { useContext, useState } from "react";
import { groupContext } from "../index.js";
import ImageHovered from "../imageHovered/imageHovered.js";
import "./suggestionsImage.css";
export default function SuggestionsImage(props) {
    var _a, _b;
    const context = useContext(groupContext);
    const [openedImage] = useState(props.imageName);
    const [hovered, setHovered] = useState(false);
    const imgProps = {
        offers: (_b = (_a = context.categories
            .find((c) => c.images.some((i) => i.name === openedImage))) === null || _a === void 0 ? void 0 : _a.offers.filter((offer) => offer.forEveryImage === true)) !== null && _b !== void 0 ? _b : [],
        imageUrl: `/api/public/users/gallery/image/${openedImage}`,
    };
    return (React.createElement("div", { className: "zoom-image-container suggestions-image-container-box", onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), onTouchEnd: () => setHovered(true) },
        React.createElement("img", { className: "suggestions-image", onContextMenu: (event) => event.preventDefault(), onDragStart: (event) => event.preventDefault(), src: imgProps.imageUrl }),
        hovered && (React.createElement(ImageHovered, { imageName: openedImage, imageUrl: imgProps.imageUrl, offers: imgProps.offers, openZoom: () => { }, showHoverEffect: false, showZoomButton: false, onOfferSelect: props.onOfferSelect, intentSource: "auto-suggestion" }))));
}
